export default __webpack_public_path__ + "static/mergeVideo-de61d4cdf815c676f8ecfaf37568a231.mp4";